<ng-container *ngIf="question">
  <bepatient-question-title-v3
    [title]="question.label"
    [constraints]="question.constraints"
    [color]="color"
    [errors]="question.errors"
    [css]="question.css"
    [key]="question.key"
    [value]="value"
    [dirty]="dirty"
    [type]="question.controlType"
    [formGroup]="formGroup"
    [hasCondition]="question.hasCondition"
  >
  </bepatient-question-title-v3>

  <div [formGroup]="formGroup">
    <div [formArrayName]="question.key">
      <ion-item *ngFor="let option of options; let i = index">
        <ion-thumbnail *ngIf="question.options[i].imageSrc"
          ><img [src]="question.options[i].imageSrc"
        /></ion-thumbnail>
        <ion-checkbox (ionChange)="isChecked()" mode="md" [formControlName]="i">
          {{ question.options[i].key }}
        </ion-checkbox>
      </ion-item>
    </div>
  </div>
</ng-container>
